import React from "react";

import { ActiveOrdersPreviewPlaceholderStyled as Styles } from "./ActiveOrdersPreview.styles";
import { ActiveOrdersPreviewPlaceholderProps as Props } from "./ActiveOrdersPreview.types";

const ActiveOrdersPreviewPlaceholder: React.FC<Props> = props => {
  return (
    <Styles className="ActiveOrdersPreviewPlaceholder">
      <div className="ActiveOrdersPreviewPlaceholder__wrapper ActiveOrdersPreviewPlaceholder__header">
        <div className="ActiveOrdersPreviewPlaceholder__shine" />
      </div>
      <div className="ActiveOrdersPreviewPlaceholder__card">
        <div className="ActiveOrdersPreviewPlaceholder__wrapper ActiveOrdersPreviewPlaceholder__title">
          <div className="ActiveOrdersPreviewPlaceholder__shine" />
        </div>
        <div className="ActiveOrdersPreviewPlaceholder__wrapper ActiveOrdersPreviewPlaceholder__description">
          <div className="ActiveOrdersPreviewPlaceholder__shine" />
        </div>
      </div>
    </Styles>
  );
};

ActiveOrdersPreviewPlaceholder.defaultProps = {};

export default ActiveOrdersPreviewPlaceholder;
